import { useTranslation } from "react-i18next";

export default function DirectNaInbraak() {
  const { t } = useTranslation("inbraakschade-reparatie");
  const steps = t("directNaInbraak.steps", { returnObjects: true }) as Array<{
    title: string;
    text: string;
  }>;

  return (
    <section className="bg-brand-cream py-16 md:py-24 w-full">
      <div className="max-w-[1440px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-2xl md:text-3xl lg:text-4xl text-brand-text tracking-tight text-center mb-10 md:mb-14">
          {t("directNaInbraak.h2")}
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {steps.map((step, i) => (
            <div
              key={i}
              className="bg-white border border-brand-border rounded-2xl p-6 md:p-8 hover:border-brand-yellow transition-colors"
            >
              <div className="w-10 h-10 rounded-full bg-brand-yellow flex items-center justify-center mb-4">
                <span className="font-geist-mono font-bold text-sm text-brand-text">
                  {String(i + 1).padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-geist font-bold text-lg text-brand-text mb-2">
                {step.title}
              </h3>
              <p className="font-geist text-sm text-brand-text/70 leading-relaxed">
                {step.text}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}